import React, { Component } from 'react';
import { bool, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Button, IconCollection, Map } from '../../components';
import {
  EXACT_LOCATION_ZOOM,
  buildLocationMapsConfig,
  onMapboxReady,
  shouldShowExactLocation,
} from '../../components/Map/locationMapPresentation';

import css from './ListingPage.module.css';
import { isPickupRequired, isDeliveryOrShippingAvailable } from '../../util/data';
import { FormattedMessage } from '../../util/reactIntl';
import StoreHoursMaybe from './StoreHoursMaybe';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStatic: true,
      hasUserZoomed: false,
    };
    this.unsubscribeMapboxReady = null;
    // this.openDirections = this.openDirections.bind(this);
    this.handleZoomChange = this.handleZoomChange.bind(this);
  }

  // Render the static image first, then upgrade to the interactive map once
  // Mapbox GL has loaded so the +/- zoom controls become usable (RAS-2473).
  componentDidMount() {
    this.unsubscribeMapboxReady = onMapboxReady(() => this.setState({ isStatic: false }));
  }

  componentWillUnmount() {
    if (this.unsubscribeMapboxReady) {
      this.unsubscribeMapboxReady();
      this.unsubscribeMapboxReady = null;
    }
  }

  handleZoomChange(zoomed) {
    this.setState({ hasUserZoomed: zoomed });
  }

  // openDirections(lat, lng, userLat, userLng) {
  //   if (typeof window === "undefined") {
  //     console.warn("Window is not defined. Cannot open maps.");
  //     return;
  //   }

  //   if (!lat || !lng) {
  //     console.warn("Invalid destination coordinates");
  //     return;
  //   }

  //   if (!userLat || !userLng) {
  //     console.warn("Invalid user coordinates, defaulting to My Location");
  //   }

  //   const destination = `${lat},${lng}`;
  //   const origin = userLat && userLng ? `${userLat},${userLng}` : "My Location";

  //   const userAgent = navigator.userAgent || "";
  //   const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  //   let mapURL;

  //   if (isIOS) {
  //     // Apple Maps for iOS
  //     mapURL = `http://maps.apple.com/?saddr=${encodeURIComponent(origin)}&daddr=${destination}`;
  //   } else {
  //     // Google Maps for Android & desktop
  //     mapURL = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${destination}`;
  //   }

  //   // Detect if running in a WebView/mobile app wrapper
  //   const isWebView = this.detectWebView();

  //   // In WebView/mobile app, use location.href to navigate away and open native app
  //   // In regular browser, use window.open to open in new tab
  //   if (isWebView) {
  //     window.location.href = mapURL;
  //   } else {
  //     window.open(mapURL, "_blank", "noopener,noreferrer");
  //   }
  // }

  // detectWebView() {
  //   if (typeof window === "undefined" || typeof navigator === "undefined") {
  //     return false;
  //   }

  //   if (window.__APP_WRAPPER__) return true;

  //   const userAgent = navigator.userAgent || "";

  //   // Common WebView indicators
  //   const webViewPatterns = [
  //     /wv/i,                    // Android WebView
  //     /WebView/i,               // Generic WebView
  //     /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i, // iOS WebView without Safari
  //     /Android.*Version\/[\d.]+.*Chrome\/[\d.]+.*Mobile.*wv/i, // Android WebView
  //   ];

  //   // Check user agent
  //   const isWebViewByUA = webViewPatterns.some(pattern => pattern.test(userAgent));

  //   // Check if window has WebView-specific properties
  //   // Some app wrappers expose custom properties
  //   const hasWebViewProperties =
  //     window.ReactNativeWebView !== undefined ||
  //     window.webkit?.messageHandlers !== undefined ||
  //     window.Android !== undefined;

  //   // Check if running in standalone mode (PWA) - if so, it's not a WebView
  //   const isStandalone = window.navigator.standalone === true ||
  //     window.matchMedia('(display-mode: standalone)').matches;

  //   // If standalone, it's likely a PWA, not a WebView
  //   if (isStandalone) {
  //     return false;
  //   }

  //   return isWebViewByUA || hasWebViewProperties;
  // }



  render() {
    const { className, rootClassName, geolocation = {}, publicData, listingId, mapsConfig, title, currentUserOrigin = {}, city, region, country, showAddressInMarketplace, listingDistance, showInMiles, storeHours, storeTimeZone } = this.props;
    const accessOptions = publicData?.access_to_rentals || [];
    const additionalFees = publicData?.additionalFees || [];
    const showPickupPill = isPickupRequired(accessOptions);
    const showDeliveryPill = isDeliveryOrShippingAvailable(accessOptions, additionalFees);
    const cityCountryLine = [city, region || country].filter(Boolean).join(', ');
    const distance = showInMiles ? listingDistance?.miles : listingDistance?.kilometers;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.panel, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    // The owner can opt into publishing their exact address from Store Settings
    // (author profile flag). Fail safe to the privacy circle whenever the address
    // itself is missing, so we never render a pin next to a blank address row.
    const showExactLocation = shouldShowExactLocation(showAddressInMarketplace, address);

    // Coarse city/country line that pairs with the privacy circle when the owner
    // hasn't opted in. When exact location is on, the address is shown once, inline
    // in the pickup-confirmed message below the map - not repeated up here.
    const locationLine = !showExactLocation ? cityCountryLine : null;

    const enhancedMapsConfig = buildLocationMapsConfig(mapsConfig, showExactLocation);

    const mapProps = {
      address,
      title,
      center: geolocation,
      obfuscatedCenter: geolocation, // Use actual location for accurate circle
      mapsConfig: enhancedMapsConfig,
      useStaticMap: this.state.isStatic,
      onZoom: this.handleZoomChange,
      showFuzzyCircleInitially: !showExactLocation,
      ...(showExactLocation ? { zoom: EXACT_LOCATION_ZOOM } : {}),
    };
    const map = <Map {...mapProps} />;

    return (
      <div className={classes}>
        <div className={css.headingMapRow}>
          <h3 className={css.headingMap}>
            <FormattedMessage id="SectionMapMaybe.itemLocation" />
          </h3>
          {!!distance && (
            <span className={css.headingMapDistance}>
              <FormattedMessage
                id={showInMiles ? 'ListingPageHeader.milesAway' : 'ListingPageHeader.kmAway'}
                defaultMessage={showInMiles ? '{distance} miles away' : '{distance} km away'}
                values={{ distance }}
              />
            </span>
          )}
        </div>
        {locationLine && (
          <div className={css.locationCityRow}>
            <i className="ri-map-pin-2-line" aria-hidden="true"></i>
            <span>{locationLine}</span>
          </div>
        )}
        {(showDeliveryPill || showPickupPill) && (
          <div className={css.locationPills}>
            {showDeliveryPill && (
              <span className={css.locationPill}>
                <FormattedMessage
                  id="SectionMapMaybe.accessOption.deliveryAvailable"
                  defaultMessage="Delivery Available"
                />
              </span>
            )}
            {showPickupPill && (
              <span className={css.locationPill}>
                <FormattedMessage
                  id="SectionMapMaybe.accessOption.pickupAvailable"
                  defaultMessage="Pickup Available"
                />
              </span>
            )}
          </div>
        )}
        <div className={css.mapBox}>
          {map}
        </div>
        {showExactLocation ? (
          <div className={`${css.locationMessage} ${css.locationMessagePickup}`}>
            <FormattedMessage
              id="SectionMapMaybe.pickupConfirmedMessage"
              values={{
                addressLine: (
                  <span className={css.pickupAddressLine}>
                    <i className="ri-map-pin-2-line" aria-hidden="true" />
                    <strong>{address}</strong>
                  </span>
                ),
              }}
            />
          </div>
        ) : (
          <div className={css.locationMessage}>
            <IconCollection className={css.infoIcon} name="info" />
            <FormattedMessage
              id="SectionMapMaybe.exactLocationAfterBooking"
            />
          </div>
        )}
        <StoreHoursMaybe storeHours={storeHours} storeTimeZone={storeTimeZone} />
        {/* <Button type="button" onClick={() => this.openDirections(geolocation.lat, geolocation.lng, currentUserOrigin.lat, currentUserOrigin.lng)} className={css.directionBtn} variant='danger' arrow="right" icon={<IconCollection name="map_pin" />}>
          <FormattedMessage id="SectionMapMaybe.getDirection" />
        </Button> */}
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
  showAddressInMarketplace: false,
  listingDistance: null,
  showInMiles: false,
  storeHours: null,
  storeTimeZone: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
  city: string,
  region: string,
  country: string,

  // Author profile flag (publicData.showAddressInMarketplace). When true and the
  // listing has an address, the map shows a precise pin plus the address text
  // instead of the privacy radius circle. Defaults to false.
  showAddressInMarketplace: bool,

  // Distance between the viewer and the listing, same shape/source as
  // ListingPageHeader's distance pill (see util/data.js#calculateDistance).
  listingDistance: shape({
    miles: number,
    kilometers: number,
  }),
  showInMiles: bool,

  // Author profile's publicData.storeHours, as configured in StoreHoursPage. When absent
  // or every day is disabled, the store-hours section under the map is hidden entirely.
  storeHours: object,

  // IANA timezone of the store's own location (see storeHoursUtils#getStoreTimeZone), used to
  // evaluate the store-hours open/closed status at the store's location rather than the
  // viewer's or server's local time.
  storeTimeZone: string,
};

export default SectionMapMaybe;